import { Image } from "expo-image";
import { Modal, View } from "native-base";
import { useEffect, useRef, useState } from "react";
import { Platform, Pressable } from "react-native";
import Video, { VideoRef } from "react-native-video";
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';


export const MediaModal = ({
  open,
  setOpen,
  musicUrl,
  list,
  defaultIndex
}:{
  open: boolean;
  setOpen: (open: boolean) => void;
  musicUrl: string;
  list: {video?: string, image: string}[];
  defaultIndex: number;
}) => {
  const [index, setIndex] = useState(0);
  const [checkData, setCheckData] = useState<{video?: string; image: string}>({ image: "" });
  const [pause, setPause] = useState(true);
  const videoRef = useRef<VideoRef>(null);
  const audioRef = useRef<VideoRef>(null);
  
  const checkoutIndex = ()=>{

  }

  useEffect(()=>{
    setIndex(defaultIndex);
    setCheckData(list[defaultIndex] || {image: ""});
  },[list,defaultIndex]);

  useEffect(()=>{
    if(!open && videoRef.current && audioRef.current){
      videoRef.current.seek(0);
      setPause(true);
      audioRef.current.seek(0);
    }
  },[open]);

  return (
    <Modal isOpen={open} onClose={() => setOpen(false)} size="full"
      justifyContent="center" alignItems="center"
      style={{
        width: "100%", maxWidth: 460,
        marginLeft: "auto", marginRight: "auto",
      }}>
      <Modal.CloseButton _icon={{ color: "white" }} position="absolute" right={2} top={Platform.OS === 'ios' ? 12 : 2} zIndex={2} />

      <View style={{ width: "100%", height: "100%" }}>

        <Video source={{ uri: musicUrl }} style={{ width: 0, height: 0 }}
          paused={pause} ref={audioRef}
        />

        <Pressable onPress={()=> {
          if(videoRef.current) setPause(!pause);
        } }
          style={{ width: "100%", height: "100%", position: "relative" }}>
          {checkData.video ? (
            <Video style={{ width: "100%", height: "100%" }}
              resizeMode="cover"
              ref={videoRef}
              source={{ uri: checkData.video}}
              paused={pause}
              onEnd={()=> {
                if(audioRef.current){ audioRef.current.seek(0); }
                setPause(true);
              }}
            />
          ) : (
            <Image source={ checkData.image }
            style={{
              width: "100%", height: "100%",
            }} />
          )}
          {checkData.video && pause && (
            <View style={{
              position: "absolute", top: 0, left: 0,
              width: "100%", height: "100%",
              justifyContent: "center", alignItems: "center",
            }}>
              <FontAwesome6 name="play" size={100} color="#FFFFFF9A" />
            </View>
          )}
        </Pressable>
      </View>
    </Modal>
  )
};